export default "__VITE_ASSET__BKW3ssJ$__"